<template>
  <div class="loader">
    <Vue3Lottie :animationData="animation" class="animationContainer" />
  </div>
</template>

<script>
import { Vue3Lottie } from 'vue3-lottie';
import clearAnimation from '@/assets/animations/clearLoadingAnimation.json';
import darkAnimation from '@/assets/animations/darkLoadingAnimation.json';
import { useTheme } from 'vuetify';
import { ref, watch } from 'vue';

export default {
  name: "LoadingElement",
  components: {
    Vue3Lottie,
  },
  setup() {
    const theme = useTheme();
    const animation = ref(
      theme.global.name.value === 'dark' ? darkAnimation : clearAnimation
    );

    // Optionnel : réagir si le thème change dynamiquement
    watch(
      () => theme.global.name.value,
      (newTheme) => {
        animation.value = newTheme === 'dark' ? darkAnimation : clearAnimation;
      }
    );

    return {
      animation,
    };
  },
};
</script>

<style scoped>
.animationContainer {
  padding: 13vw;
}

.loader {
  width: 100%;
  height: 100%;
  backdrop-filter: blur(7px);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
</style>
